/*
创建者 魏强(2018.1.28)
企业品牌 右边商品
*/
<template>
	<div class="module-brand-right">
        <ul class="frd-list clearfix">
            <!-- 首页-企业品牌右边商品 -->
            <li v-for="(item,index) in list" :key="index">
                <router-link :to="item.to" target="_blank">
                    <img :src="item.atturl" height="199" :alt="item.aname" width="227">
                </router-link>
            </li>
        </ul>
    </div>
</template>
<script>
import {parseAdvList} from "utils/tool.js";
export default {
    props:["qyRightGoodsAdv"],
	data(){
		return {
            list:parseAdvList(this.qyRightGoodsAdv.advList)
		}
	},
	created(){
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?9b7d26c4